<template>
  <div id="Admin_Payment_Receipt_Show">
    <!-- 繳款項目-詳細資料 -->
    <div class="row">
      <span id="Receipt_Show_Table"></span>
      <table
        class="table table-bordered table-hover receipt-table white-color"
        aria-describedby="Receipt_Show_Table"
      >
        <thead class="thead-dark">
          <tr>
            <th scope="col" colspan="2">
              繳款項目-詳細資料
            </th>
          </tr>
        </thead>
        <!-- 項目內容 -->
        <tbody>
          <tr>
            <th scope="col">
              收費項目編號
            </th>
            <td>
              {{ DetailData.FeeItemId }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳款項目編號</th>
            <td>
              {{ DetailData.FeeOrderId }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳款項目建立時間</th>
            <td>
              {{ DetailData.FeeOrderDT }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳款項目所屬人員帳號</th>
            <td>
              {{ DetailData.UserId }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳款項目所屬人員姓名</th>
            <td class="nukWord">
              {{ DetailData.UserName }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳款項目說明事由</th>
            <td>
              {{ DetailData.FeeOrderDesc }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳費金額</th>
            <td>
              {{ DetailData.PayAmt }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳費方式</th>
            <td>
              {{ PayTypes }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳費期限類型</th>
            <td>
              {{ DetailData.PayDeadLine }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳費期限日期</th>
            <td>
              {{ DetailData.PayDateBegin }} 至 {{ DetailData.PayDateEnd }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳費期限起始</th>
            <td>
              {{ DetailData.PayDateBegin }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳費期限截止</th>
            <td>
              {{ DetailData.PayDateEnd }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳費通路種類</th>
            <td>
              {{ PayCategorys }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳費時間</th>
            <td>
              {{ DetailData.PayDT }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳費單號</th>
            <td>
              {{ DetailData.PayOrderId }}
            </td>
          </tr>
          <tr>
            <th scope="col">手續費金額</th>
            <td>
              {{ DetailData.PayCharge }}
            </td>
          </tr>
          <tr>
            <th scope="col">收據抬頭</th>
            <td class="nukWord">
              {{ DetailData.ReceiptTitle }}
            </td>
          </tr>
          <tr>
            <th scope="col">是否需要收據(是/否)</th>
            <td class="nukWord">
              <span v-if="DetailData.NeedReceipt === 0">
                {{ '否' }}
              </span>
              <span v-else>
                {{ '是' }}
              </span>
            </td>
          </tr>
          <tr>
            <th scope="col">公司統編</th>
            <td>
              {{ DetailData.CompanyTaxId }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳款項目入帳日期</th>
            <td>
              {{ DetailData.DebtDate }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳款項目入帳備註</th>
            <td>
              {{ DetailData.DebtRemark }}
            </td>
          </tr>
          <tr>
            <th scope="col">入帳收據編號(虛擬收據編號)</th>
            <td>
              {{ DetailData.ReceiptDebt }}
            </td>
          </tr>
          <tr>
            <th scope="col">銷帳批號</th>
            <td>
              {{ DetailData.DebtConfirmNo }}
            </td>
          </tr>
          <tr>
            <th scope="col">正式收據編號</th>
            <td>
              {{ DetailData.ReceiptFormal }}
            </td>
          </tr>
          <tr>
            <th scope="col">繳款項目狀態</th>
            <td>
              {{ FeeOrderStatuss }}
            </td>
          </tr>
          <tr>
            <th scope="col">作廢時間</th>
            <td>
              {{ DetailData.CancelDT }}
            </td>
          </tr>
          <tr>
            <th scope="col">處理狀態</th>
            <td>
              <select class="input-style" v-model="ProcessStatuss">
                <option
                  v-for="data in ProcessStatusSelect"
                  :key="data.id"
                  :value="data.value"
                >
                  {{ data.text }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th scope="col">退費單號</th>
            <td>
              {{ DetailData.RefundId }}
            </td>
          </tr>
          <tr>
            <th scope="col">退費金額</th>
            <td>
              {{ DetailData.RefundAmt }}
            </td>
          </tr>
          <tr>
            <th scope="col">退費原因</th>
            <td>
              {{ DetailData.RefundReason }}
            </td>
          </tr>
          <tr>
            <th scope="col">傳票日期</th>
            <td>
              {{ DetailData.SummonsDate }}
            </td>
          </tr>
          <tr>
            <th scope="col">傳票編號</th>
            <td>
              {{ DetailData.SummonsId }}
            </td>
          </tr>
          <tr>
            <th scope="col">備註</th>
            <td>
              <textarea
                class="form-control"
                rows="3"
                v-model="DetailData.Remark"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 上一頁 -->
    <v-button
      class="mb-2"
      btn-text="修改"
      btnType="primary"
      @click.native="PostFeeorderEdit"
    />
    <v-button
      class="ml-2 mb-2"
      btn-text="回上一頁"
      btnType="secondary"
      @click.native="GoToReceipt"
    />
  </div>
</template>

<script>
import $ from 'jquery'
import md5 from 'js-md5'
import { fillcompile } from '../../../Api/compile'
import { apiFeeorderQuerydetail, apiFeeorderEdit } from '../../../Api/api'
export default {
  props: ['id'],
  data () {
    return {
      PayTypeSelect: [
        { value: 0, text: '未繳費' },
        { value: 1, text: '國內信用卡' },
        { value: 2, text: '國外信用卡' },
        { value: 3, text: '一卡通' },
        { value: 4, text: 'LINE Pay' },
        { value: 5, text: 'WebATM' },
        { value: 6, text: '四大超商繳款' },
        { value: 7, text: '土銀臨櫃繳款' },
        { value: 8, text: '出納組現金繳納' },
        { value: 255, text: '列印繳費單(尚未實際繳費)' }
      ],
      FeeOrderStatusSelect: [
        { value: 0, text: '未繳費' },
        { value: 1, text: '已列印繳費單' },
        { value: 2, text: '已繳費' },
        { value: 3, text: '已入帳(填入虛擬收據編號後)' },
        { value: 4, text: '已申請退費' },
        { value: 5, text: '已退費完成' },
        { value: 255, text: '已作廢(需為未繳費狀態時方可作廢)' }
      ],
      ProcessStatusSelect: [
        { text: '無須處理', value: 0 },
        { text: '未處理', value: 1 },
        { text: '已處理', value: 2 }
      ],
      EditData: {
        FeeOrderId: '',
        Remark: '',
        ProcessStatus: null
      },
      DetailData: {},
      PayTypes: '',
      PayCategorys: '',
      FeeOrderStatuss: '',
      ProcessStatuss: null
    }
  },
  mounted () {
    this.PostFeeorderQuerydetailID()
  },
  methods: {
    PostFeeorderQuerydetailID () { // 查詢明細 B_API 014
      // 定義資料
      const vm = this
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      delete NewData.ApplyDeptId
      NewData.FeeOrderId = vm.id
      // 判斷權限
      const Backend = sessionStorage.getItem('Backend')
      const admin = md5('業務')
      if (admin === Backend) {
        NewData.DeptId = UserData.DeptId
      } else {
        NewData.DeptId = ''
      }
      NewData.FeeItemId = ''
      NewData.PayDTStart = ''
      NewData.PayDTEnd = ''
      NewData.PayType = null
      NewData.FeeOrderStatus = null
      // 呼叫API
      apiFeeorderQuerydetail(NewData).then(
        res => {
          if (res !== undefined) {
            vm.DetailData = res.Data[0]
            vm.DataSelect()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostFeeorderEdit () { // 備註編輯 B_API 017
      // 定義資料
      const vm = this
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      vm.EditData.FeeOrderId = vm.DetailData.FeeOrderId
      vm.EditData.Remark = vm.DetailData.Remark
      vm.EditData.ProcessStatus = vm.ProcessStatuss
      const NewEditData = Object.assign(JSON.parse(sessionStorage.getItem('Identity')), vm.EditData)
      delete NewEditData.ApplyDeptId
      NewEditData.DeptId = UserData.DeptId
      // 呼叫API
      apiFeeorderEdit(NewEditData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('Modals', '修改成功。')
            $('#CheckOk').modal('show')
            vm.PostFeeorderQuerydetailID()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    DataSelect () { // 判斷資料項目
      const vm = this
      const PayTypeselsect = vm.PayTypeSelect
      const PayCategory = vm.DetailData.PayCategory
      const FeeOrderStatusSelect = vm.FeeOrderStatusSelect
      const ProcessStatusSelect = vm.ProcessStatusSelect
      for (let i = 0; i < PayTypeselsect.length; i++) {
        if (PayTypeselsect[i].value === vm.DetailData.PayType) {
          vm.PayTypes = PayTypeselsect[i].text
        }
      }
      for (let i = 0; i < FeeOrderStatusSelect.length; i++) {
        if (FeeOrderStatusSelect[i].value === vm.DetailData.FeeOrderStatus) {
          vm.FeeOrderStatuss = FeeOrderStatusSelect[i].text
        }
      }
      for (let i = 0; i < ProcessStatusSelect.length; i++) {
        if (ProcessStatusSelect[i].value === vm.DetailData.ProcessStatus) {
          vm.ProcessStatuss = ProcessStatusSelect[i].value
        }
      }
      vm.PayCategorys = fillcompile(PayCategory)
    },
    GoToReceipt () {
      this.$router.push({ name: 'Admin-ReceiptReport' })
    }
  }
}
</script>
